module.exports = __webpack_public_path__ + "img/demo-expert-stats.b75f5a6d.png";